import React, { useState, useEffect, useRef } from "react";
import { useSearchBox } from "react-instantsearch";

export default function DebouncedSearchBox({ placeholder, className }) {
  const { query, refine } = useSearchBox();
  const [value, setValue] = useState(query);
  const timerRef = useRef(null);

  // Sync external query changes (e.g. browser back/forward)
  useEffect(() => {
    setValue(query);
  }, [query]);

  const onChange = (e) => {
    const v = e.target.value;
    setValue(v);
    clearTimeout(timerRef.current);
    // Ne déclenche la recherche qu'à partir de 3 caractères (ou champ vide = reset)
    if (v.length === 0 || v.length >= 3) {
      timerRef.current = setTimeout(() => refine(v), 300);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    clearTimeout(timerRef.current);
    // Entrée : recherche immédiate si 3+ caractères ou champ vide
    if (value.length === 0 || value.length >= 3) {
      refine(value);
    }
  };

  const onReset = () => {
    clearTimeout(timerRef.current);
    setValue("");
    refine("");
  };

  return (
    <div className={className ? ("ais-SearchBox " + className) : "ais-SearchBox"}>
      <form className="ais-SearchBox-form" onSubmit={onSubmit} noValidate role="search">
        <input
          className="ais-SearchBox-input"
          type="search"
          placeholder={placeholder}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          maxLength="512"
          value={value}
          onChange={onChange}
        />
        {value && (
          <button
            className="ais-SearchBox-reset"
            type="button"
            title="Effacer"
            onClick={onReset}
          >
            <svg className="ais-SearchBox-resetIcon" viewBox="0 0 20 20" width="10" height="10">
              <path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" />
            </svg>
          </button>
        )}
        <button className="ais-SearchBox-submit" type="submit" title="Rechercher">
          <svg className="ais-SearchBox-submitIcon" viewBox="0 0 20 20" width="10" height="10">
            <path d="M14.386 14.386l4.088 4.088-4.088-4.088A7.533 7.533 0 113.733 3.733a7.533 7.533 0 0110.653 10.653z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </form>
    </div>
  );
}
